import P404 from './P404'

export default P404
